module.exports = __webpack_public_path__ + "static/img/qmydh1-benefit-bg2.95a5a60b.png";